module.exports = __webpack_public_path__ + "img/1.65f3f186.png";